<template>
  <div>
    <div>
      <h3 v-if="postName == '' || getSelectedPost() == ''"> Blog </h3>
      <p><em>Share your experience with us and <a href="mailto:eatsonfeetsmail@gmail.com" target="_blank">submit a blog post!</a>
      <br />You can also use <a href="https://docs.google.com/document/d/1jwxhj1QYAEt9SZz-VEDxtsbbilXWgTPbXmHLbhTqEk4/edit?usp=sharing" target="_blank">this template</a> as a guide. We would love to add a picture as well!</em>
      </p>
<hr />
      <div class="latestInfoToc">
        <ul>
          <li>
            <router-link to="/blog">
              <span v-if="getSelectedPost() == ''">Showing</span>
              <span v-if="getSelectedPost() !== ''">Show</span>
              All Posts
            </router-link>
          </li>
          <li><router-link to="/blog/AreYouBeingScammed" :class="postName === 'AreYouBeingScammed' ? 'selectedArticle': ''">Are You Being Scammed?</router-link></li>
          <li><router-link to="/blog/TanishaMissouriVolunteer" :class="postName === 'TanishaMissouriVolunteer' ? 'selectedArticle': ''">Tanisha's Story</router-link></li>
          <li><router-link to="/blog/SellingBuyingBartering" :class="postName === 'SellingBuyingBartering' ? 'selectedArticle': ''">Selling, Buying, and Bartering</router-link></li>
          <li><router-link to="/blog/Kara" :class="postName === 'Kara' ? 'selectedArticle': ''">Kara's Milksharing Story</router-link></li>
          <li><router-link to="/blog/InfantFormulaShortage" :class="postName === 'InfantFormulaShortage' ? 'selectedArticle': ''">Infant Formula Shortage</router-link></li>
          <li><router-link to="/blog/MuhammadPonceInterview" :class="postName === 'MuhammadPonceInterview' ? 'selectedArticle': ''">Interview with Lakisa Muhammad and Michelle Ivette Ponce</router-link></li>
          <li><router-link to="/blog/MooreSalasInterview" :class="postName === 'MooreSalasInterview' ? 'selectedArticle': ''">Interview with Kimberly Moore-Salas</router-link></li>
          <li><router-link to="/blog/Echo" :class="postName === 'Echo' ? 'selectedArticle': ''">Echo's Milksharing Story</router-link></li>
          <li><router-link to="/blog/BlackLivesMatterStatement" :class="postName === 'BlackLivesMatterStatement' ? 'selectedArticle': ''">Black Lives Matter Statement</router-link></li>
          <li><router-link to="/blog/AAPResponse" :class="postName === 'AAPResponse' ? 'selectedArticle': ''">American Academy of Pediatrics Unwittingly Validates "Four Pillars of Safe Breast Milk Sharing"</router-link></li>
          <li><router-link to="/blog/CAPPApost" :class="postName === 'CAPPApost' ? 'selectedArticle': ''">What do CMAJ, Midwifery Today, Pubmed and CAPPA have to do with Eats On Feets?</router-link></li>
          <li><router-link to="/blog/MidwiferyTodayArticle" :class="postName === 'MidwiferyTodayArticle' ? 'selectedArticle': ''">Midwifery Today Article</router-link></li>
          <li><router-link to="/blog/ProfitingOffOfBreastMilk" :class="postName === 'ProfitingOffOfBreastMilk' ? 'selectedArticle': ''">Making a Profit on Breast Milk</router-link></li>
          <li><router-link to="/blog/BecomeAVolunteer" :class="postName === 'BecomeAVolunteer' ? 'selectedArticle': ''">Volunteering for an Eats on Feets chapter</router-link></li>
          <li><router-link to="/blog/CMJResponse" :class="postName === 'CMJResponse' ? 'selectedArticle': ''">Canadian Medical Association Journal Response</router-link></li>
        </ul>
      </div>
    </div>

    <div v-if="postName == '' || getSelectedPost() == ''">
      <AreYouBeingScammed />
      <hr />
      <TanishaMissouriVolunteer />
      <hr />
      <SellingBuyingBartering />
      <hr />
      <Kara />
      <hr />
      <InfantFormulaShortage />
      <hr />
      <MuhammadPonceInterview />
      <hr />
      <MooreSalasInterview />
      <hr />
      <Echo />
      <hr />
      <BlackLivesMatterStatement />
      <hr />
      <AAPResponse/>
      <hr />
      <CAPPApost/>
      <hr />
      <MidwiferyTodayArticle />
      <hr />
      <ProfitingOffOfBreastMilk/>
      <hr />
      <BecomeAVolunteer/>
      <hr />
      <CMJResponse/>
    </div>

    <AreYouBeingScammed v-if="postName === 'AreYouBeingScammed'"/>
    <TanishaMissouriVolunteer v-if="postName === 'TanishaMissouriVolunteer'"/>
    <SellingBuyingBartering v-if="postName === 'SellingBuyingBartering'"/>
    <Kara v-if="postName === 'Kara'"/>
    <InfantFormulaShortage v-if="postName === 'InfantFormulaShortage'"/>
    <MuhammadPonceInterview v-if="postName === 'MuhammadPonceInterview'"/>
    <MooreSalasInterview v-if="postName === 'MooreSalasInterview'"/>
    <Echo v-if="postName === 'Echo'"/>
    <BlackLivesMatterStatement v-if="postName === 'BlackLivesMatterStatement'"/>
    <AAPResponse v-if="postName === 'AAPResponse'"/>
    <CAPPApost v-if="postName === 'CAPPApost'"/>
    <CMJResponse v-if="postName === 'CMJResponse'"/>
    <BecomeAVolunteer v-if="postName === 'BecomeAVolunteer'"/>
    <MidwiferyTodayArticle v-if="postName === 'MidwiferyTodayArticle'"/>
    <ProfitingOffOfBreastMilk v-if="postName === 'ProfitingOffOfBreastMilk'"/>

  </div>
</template>
<script>
import AreYouBeingScammed from '../components/posts/AreYouBeingScammed'
import TanishaMissouriVolunteer from '../components/posts/TanishaMissouriVolunteer'
import SellingBuyingBartering from '../components/posts/SellingBuyingBartering'
import Kara from '../components/posts/Kara'
import InfantFormulaShortage from '../components/posts/InfantFormulaShortage'
import MuhammadPonceInterview from '../components/posts/MuhammadPonceInterview'
import MooreSalasInterview from '../components/posts/MooreSalasInterview'
import Echo from '../components/posts/Echo'
import BlackLivesMatterStatement from '../components/posts/BlackLivesMatterStatement'
import AAPResponse from '../components/posts/AAPResponse'
import CAPPApost from '../components/posts/CAPPApost'
import CMJResponse from '../components/posts/CMJResponse'
import MidwiferyTodayArticle from '../components/posts/MidwiferyTodayArticle'
import BecomeAVolunteer from '../components/posts/BecomeAVolunteer'
import ProfitingOffOfBreastMilk from '../components/posts/ProfitingOffOfBreastMilk'

import { PostsMetaInfo } from '../components/posts/postsMetaInfo'

export default {
  name: 'Blog',
  components: {
    AAPResponse,
    CAPPApost,
    CMJResponse,
    BecomeAVolunteer,
    ProfitingOffOfBreastMilk,
    MidwiferyTodayArticle,
    Echo,
    MooreSalasInterview,
    MuhammadPonceInterview,
    BlackLivesMatterStatement,
    InfantFormulaShortage,
    Kara,
    SellingBuyingBartering,
    TanishaMissouriVolunteer,
    AreYouBeingScammed
  },
  metaInfo() {
    let title = 'Blog'
    let description = ''
    const selectedPost = this.getSelectedPost()

    if (selectedPost !== '' && PostsMetaInfo[selectedPost]) {
      title = PostsMetaInfo[selectedPost].title
      description = PostsMetaInfo[selectedPost].description
    }

    return {
      title: `Eats On Feets - ${title}`,
      meta: [
        { name: 'description', content: description },
        { property: 'og:title', content: `Eats On Feets - ${title}` },
        { property: 'og:site_name', content: 'Eats On Feets' },
        { property: 'og:type', content: 'website' },
        { name: 'robots', content: 'index,follow' }
      ]
    }
  },
  props: ['postName'],
  methods: {
    getSelectedPost() {
      const pathname = location.pathname
      if (pathname.indexOf('AAPResponse') !== -1) this.postName = 'AAPResponse'
      else if (pathname.indexOf('CAPPApost') !== -1) this.postName = 'CAPPApost'
      else if (pathname.indexOf('CMJResponse') !== -1) this.postName = 'CMJResponse'
      else if (pathname.indexOf('BecomeAVolunteer') !== -1) this.postName = 'BecomeAVolunteer'
      else if (pathname.indexOf('MidwiferyTodayArticle') !== -1) this.postName = 'MidwiferyTodayArticle'
      else if (pathname.indexOf('ProfitingOffOfBreastMilk') !== -1) this.postName = 'ProfitingOffOfBreastMilk'
      else if (pathname.indexOf('Echo') !== -1) this.postName = 'Echo'
      else if (pathname.indexOf('MooreSalasInterview') !== -1) this.postName = 'MooreSalasInterview'
      else if (pathname.indexOf('MuhammadPonceInterview') !== -1) this.postName = 'MuhammadPonceInterview'
      else if (pathname.indexOf('InfantFormulaShortage') !== -1) this.postName = 'InfantFormulaShortage'
      else if (pathname.indexOf('BlackLivesMatterStatement') !== -1) this.postName = 'BlackLivesMatterStatement'
      else if (pathname.indexOf('Kara') !== -1) this.postName = 'Kara'
      else if (pathname.indexOf('SellingBuyingBartering') !== -1) this.postName = 'SellingBuyingBartering'
      else if (pathname.indexOf('TanishaMissouriVolunteer') !== -1) this.postName = 'TanishaMissouriVolunteer'
      else if (pathname.indexOf('AreYouBeingScammed') !== -1) this.postName = 'AreYouBeingScammed'
      else this.postName = ''
      return this.postName
    }
  }
}
</script>

<style lang="scss">
.selectedArticle {
  font-weight: bold;
  text-decoration: underline;
  color: $primary-light-color;
  font-size: 1.1em;
}
.timeStamp {
    font-size: 12px;
    margin-bottom: -1px;
}

</style>
